<template>
  <div class="card" :class="{ 'busy': busy }">
    <div
      v-if="busy"
      style="width:100%;height:100%;position: absolute;z-index: 10; cursor:wait;display: flex;align-items: center; justify-content: center;"
    >
      <i class="icon-ei-spinner-3 spin" style="font-size:10em;"></i>
    </div>
    <div class="card-header" v-if="!hideHeader">
      <a v-if="!hideReload" style="float: right;" @click="$emit('reload')">
        <i class="icon-reload"></i>
      </a>
      <h4 class="card-title">{{headerTitle}}</h4>
    </div>
    <div class="card-body">
      <slot name="body">
        <div class="card-block">
          <slot name="block"></slot>
        </div>
      </slot>
    </div>
    <div v-if="!hideFooter" class="card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "card",
  props: {
    hideFooter: Boolean,
    hideReload:Boolean,
    hideHeader: Boolean,
    headerTitle: String,
    busy: Boolean,
  },
};
</script>

<style>
.busy {
  opacity: 0.6;
}
</style>